/* eslint-disable */
// source: vivacity/core/red_light_crossing_event.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var vivacity_core_classifying_detector_class_types_pb = require('../../vivacity/core/classifying_detector_class_types_pb.js');
goog.object.extend(proto, vivacity_core_classifying_detector_class_types_pb);
goog.exportSymbol('proto.vivacity.core.RedLightCrossingEvent', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.RedLightCrossingEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.RedLightCrossingEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.RedLightCrossingEvent.displayName = 'proto.vivacity.core.RedLightCrossingEvent';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.RedLightCrossingEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.RedLightCrossingEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.RedLightCrossingEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    visionProgramId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    countlineId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    redLightVisionProgramId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    crossingTimestampMicroseconds: jspb.Message.getFieldWithDefault(msg, 5, 0),
    redLightState: jspb.Message.getFieldWithDefault(msg, 6, 0),
    trackNumber: jspb.Message.getFieldWithDefault(msg, 8, 0),
    restartNumber: jspb.Message.getFieldWithDefault(msg, 9, 0),
    classId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    transitionTimestampMicroseconds: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.RedLightCrossingEvent}
 */
proto.vivacity.core.RedLightCrossingEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.RedLightCrossingEvent;
  return proto.vivacity.core.RedLightCrossingEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.RedLightCrossingEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.RedLightCrossingEvent}
 */
proto.vivacity.core.RedLightCrossingEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVisionProgramId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCountlineId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRedLightVisionProgramId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCrossingTimestampMicroseconds(value);
      break;
    case 6:
      var value = /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (reader.readEnum());
      msg.setRedLightState(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTrackNumber(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRestartNumber(value);
      break;
    case 11:
      var value = /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (reader.readEnum());
      msg.setClassId(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTransitionTimestampMicroseconds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.RedLightCrossingEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.RedLightCrossingEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.RedLightCrossingEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisionProgramId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCountlineId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getRedLightVisionProgramId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCrossingTimestampMicroseconds();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getRedLightState();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTrackNumber();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getRestartNumber();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getClassId();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getTransitionTimestampMicroseconds();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
};


/**
 * optional uint32 vision_program_id = 1;
 * @return {number}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getVisionProgramId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setVisionProgramId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 countline_id = 2;
 * @return {number}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getCountlineId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setCountlineId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 red_light_vision_program_id = 3;
 * @return {number}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getRedLightVisionProgramId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setRedLightVisionProgramId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 crossing_timestamp_microseconds = 5;
 * @return {number}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getCrossingTimestampMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setCrossingTimestampMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional ClassifyingDetectorClassTypes red_light_state = 6;
 * @return {!proto.vivacity.core.ClassifyingDetectorClassTypes}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getRedLightState = function() {
  return /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.vivacity.core.ClassifyingDetectorClassTypes} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setRedLightState = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional uint32 track_number = 8;
 * @return {number}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getTrackNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setTrackNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 restart_number = 9;
 * @return {number}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getRestartNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setRestartNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional ClassifyingDetectorClassTypes class_id = 11;
 * @return {!proto.vivacity.core.ClassifyingDetectorClassTypes}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getClassId = function() {
  return /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.vivacity.core.ClassifyingDetectorClassTypes} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setClassId = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional uint64 transition_timestamp_microseconds = 12;
 * @return {number}
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.getTransitionTimestampMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightCrossingEvent} returns this
 */
proto.vivacity.core.RedLightCrossingEvent.prototype.setTransitionTimestampMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


goog.object.extend(exports, proto.vivacity.core);
